import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useSession } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useSession();

  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center bg-background text-foreground"
      >
        <Loader2 className="h-5 w-5 animate-spin text-accent" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
